import type { FC, ReactNode } from 'react'
import type { SourceItem } from '@/types'

import { ExternalLink } from 'lucide-react'

interface SourcesProps {
    items: SourceItem[]
    className?: string
}

export const Sources: FC<SourcesProps> = ({ items, className }): ReactNode => {
    if (items.length === 0) return null

    return (
        <section aria-labelledby='sources-heading' className={className}>
            <h2 id='sources-heading' className='font-heading text-2xl font-bold tracking-tight'>
                Sources
            </h2>

            <p className='mt-2 text-sm text-muted-foreground'>
                Published research and guidance this page draws on. Check the original where a detail
                matters to you.
            </p>

            <ol className='mt-5 space-y-3'>
                {items.map((item, index) => (
                    <li key={item.url} className='flex gap-3 text-sm leading-relaxed'>
                        <span className='mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-full bg-secondary text-[11px] font-semibold text-secondary-foreground'>
                            {index + 1}
                        </span>

                        <span>
                            <a
                                href={item.url}
                                target='_blank'
                                rel='noopener noreferrer nofollow'
                                className='font-medium text-primary hover:underline'
                            >
                                {item.label}
                                <ExternalLink className='ml-1 inline size-3.5 align-[-2px]' aria-hidden='true' />
                            </a>
                            <span className='block text-muted-foreground'>{item.publisher}</span>
                        </span>
                    </li>
                ))}
            </ol>
        </section>
    )
}
